var path = '/pages/guestlists/views/pages/rsvps/details/changelog.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<al-entity-change-log ng-if=\"!vm.loading\" entity=\"'rsvp'\" entity-id=\"vm.rsvp.id\"></al-entity-change-log>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/details/changelog.tpl.html
// module id = 2277
// module chunks = 1